import { render, staticRenderFns } from "./S701.vue?vue&type=template&id=88a9791c&scoped=true"
import script from "./S701.vue?vue&type=script&lang=js"
export * from "./S701.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=88a9791c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a9791c",
  null
  
)

export default component.exports